module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Med.svg?v=77c708aee8234663f06620c63a02ec77";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Med.svg
// module id = 633
// module chunks = 0